import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RmService } from '../../../services/rm/rm.service';

@Component({
  selector: 'app-rm-search',
  templateUrl: './rm-search.component.html',
  styleUrls: ['./rm-search.component.scss']
})
export class RmSearchComponent implements OnInit {
  keyword = '';
  gender = '';
  min_age: number | null = null;
  max_age: number | null = null;
  profiles: any[] = [];
  loading = false;
  searched = false;

  constructor(private rmService: RmService, private router: Router) {}

  ngOnInit(): void {
    this.onSearch();
  }

  onSearch(): void {
    this.loading = true;
    this.searched = true;
    const filters: any = { limit: 50 };
    if (this.keyword.trim()) filters.keyword = this.keyword.trim();
    if (this.gender) filters.gender = this.gender;
    if (this.min_age) filters.min_age = this.min_age;
    if (this.max_age) filters.max_age = this.max_age;

    this.rmService.searchProfiles(filters).subscribe({
      next: res => {
        this.loading = false;
        if (res.status === 'success') {
          this.profiles = res.data || [];
        }
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  backToDashboard(): void {
    this.router.navigate(['/rm/dashboard']);
  }
}
